import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import * as i0 from "@angular/core";
import * as i1 from "ngx-clipboard";
import * as i2 from "ngx-toastr";
var CopyService = /** @class */ (function () {
    function CopyService(_clipboardService, toastrService) {
        this._clipboardService = _clipboardService;
        this.toastrService = toastrService;
    }
    // 引数で渡された文字列をクリップボードにコピー
    CopyService.prototype.copyToClipboard = function (text) {
        this._clipboardService.copyFromContent(text);
        this.toastrService.info('コピーが完了しました。');
    };
    // 選択範囲の文字列を返却
    CopyService.prototype.selectedText = function () {
        var text = '';
        if (window.getSelection) {
            text = window.getSelection().toString();
        }
        return text;
    };
    CopyService.ngInjectableDef = i0.defineInjectable({ factory: function CopyService_Factory() { return new CopyService(i0.inject(i1.ClipboardService), i0.inject(i2.ToastrService)); }, token: CopyService, providedIn: "root" });
    return CopyService;
}());
export { CopyService };
